export default __webpack_public_path__ + "static/media/SHOWMELOCAL.2260e487.png";